<template>
    <div class="footerwavebg">
        <img :src="`https://p3.udn.com.tw/wish/images/common/footer_${selectSrc_3('mob', 'pad', 'pc')}.svg`"/>
    </div>
</template>

<script>
    import {selectSrcMethod_3} from "@/assets/js/utils/masterBuilder.js";
    export default {
        mixins: [selectSrcMethod_3],
        data(){
            return{
            }
        },
        components: {
        },
        methods:{
        },
    }
</script>

<style lang="scss" scoped>
    .footerwavebg{
        width: 100%;
        img{
            width: 100%;
        }
    }
</style>